export const domain = 'NavigationModel'

export const onChangeCurrentScene = `${domain}/onChangeCurrentScene`
export const onChangeCurrentProjectId = `${domain}/onChangeCurrentProjectId`
export const onChangeCurrentConversationId = `${domain}/onChangeCurrentConversationId`
export const onSetIsDrawerNavigationOpened = `${domain}/onSetIsDrawerNavigationOpened`
export const onSetIsCardMoreOptionsActionSheetOpened = `${domain}/CardMoreOptionsActionSheetOpened`
export const onSetIsNavigationStateLoaded = `${domain}/onSetIsNavigationStateLoaded`
